import styled from 'styled-components';
import { BREAKPOINT, REBRAND_COLOR } from '@latitude/core/utils/constants';
import { PADDING } from '@/utils/constants';

export const FilterWrapper = styled.div`
  width: 100%;
`;

/* Mobile-first: visible by default */
export const Dropdown = styled.select`
  width: 100%;
  padding: ${PADDING.P16} ${PADDING.P16} ${PADDING.P16} ${PADDING.P24};
  border-radius: 8px;
  border: 1px solid #d6d6d6;
  font-family: Latitude Sans;
  font-weight: 600;
  option {
    color: ${REBRAND_COLOR.INDIGO};
    font-size: 16px;
    line-height: 22px;
  }
  &:focus {
    outline: none;
    border: 1px solid #d6d6d6;
  }

  @media (min-width: ${BREAKPOINT.LG}) {
    display: none;
  }
`;

export const ButtonGroup = styled.div`
  display: none;
  gap: 12px;

  @media (min-width: ${BREAKPOINT.LG}) {
    display: flex;
  }
`;

export const FilterButton = styled.button`
  padding: ${PADDING.P8} ${PADDING.P24};
  min-width: 161px;
  height: 38px;
  border-radius: 64px;
  color: ${REBRAND_COLOR.INDIGO};
  cursor: pointer;

 ${({ active, inactiveColor }) => `
  background: ${active ? REBRAND_COLOR.GREEN : inactiveColor || REBRAND_COLOR.STONE};
  color: ${REBRAND_COLOR.INDIGO};
`}
`;
